import tagTester from './_tagTester.js';

export default tagTester('WeakSet');



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/isWeakSet.js
// module id = 501
// module chunks = 8